import styled from "styled-components";

export const ConfirmModalText = styled.div`
    &{
        font-size: 16px;
        padding: 24px 16px;
    }
`;
